import React, { FC } from 'react'
import GenericModal from '../../../widgets/GenericModal'
import { APP_NAME } from '../../../constants'
import { useUserContext } from '../../../contexts/UserContext'
import { getProPricing } from '../../../utils/pricingUtils'
import { useGetActiveProjectsQuery } from '../../../redux/services/skeema/projects.endpoints'

interface Props {
  isOpen: boolean
  onCancel: () => void
  onSubmit: () => void
}

const ProjectLimitModal: FC<Props> = (props) => {
  const { isOpen, onCancel, onSubmit } = props
  const { userInfo } = useUserContext()
  const pricingPlan = userInfo ? getProPricing(userInfo) : null
  const { data: projects } = useGetActiveProjectsQuery(undefined)
  const numFolders = projects?.length ?? 0

  return (
    <GenericModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSubmit={onSubmit}
      headingText="You're on a roll! 🚀"
      bodyText={
        <>
          You&apos;ve created {numFolders} folder{numFolders === 1 ? '' : 's'} with {APP_NAME}{' '}
          Basic.
          <br />
          <br />
          Upgrade to Pro for up to 100 folders, plus AI-powered Sessions, to keep all your projects
          organized.
        </>
      }
      cancelButtonText="Dismiss"
      submitButtonText={`Upgrade for $${pricingPlan?.yearly} per month`}
      submitSubtext="Less than a fancy coffee ☕"
    />
  )
}

export default ProjectLimitModal
